/* eslint-disable react/jsx-newline */
import { useTranslation } from "next-i18next";
import Link from "next/link";
import { Language } from "../../config/LanguageConfiguration";
import {
  TranslatableText,
  TranslatableTextAndReactElement,
} from "../interfaces/TranslatableText";
import theme from "../layouts/theme";

export interface ImprintProps {
  title: TranslatableText;
  text: TranslatableTextAndReactElement;
}

export const useImprint = (): ImprintProps => {
  const { t } = useTranslation<"common">();

  return {
    title: {
      [Language.German]: "Impressum",
      [Language.English]: "Imprint",
    },
    text: {
      [Language.German]: (
        <>
          <h2>Angaben gemäß § 5 TMG</h2>

          <p>
            NWON GmbH
            <br /> Taunusstr. 59-61
            <br /> c/o Gutenberg Digital Hub
            <br /> 55118 Mainz
            <br /> Handelsregister: HRB 50583
            <br /> Registergericht: Amtsgericht Mainz
            <br />
            <br />
            <strong>Vertreten durch:</strong>
            <br /> Felix Buchmüller
          </p>

          <h2>Kontakt</h2>

          <p>
            Telefon: <Link href="tel:+4961316246560">+49 6131 6246 560</Link>
            <br /> E-Mail: <Link href="mailto:t()">hallo@nwon.de</Link>
          </p>

          <h2>Verbraucher­streit­beilegung/Universal­schlichtungs­stelle</h2>

          <p>
            Wir sind nicht bereit oder verpflichtet, an
            Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
            teilzunehmen.
            <br /> Quelle:&nbsp;
            <a
              href="https://www.e-recht24.de/"
              target="_blank"
              rel="noreferrer"
              style={{ color: theme.palette.primary.main }}
            >
              eRecht24
            </a>
          </p>
        </>
      ),
      [Language.English]: (
        <>
          <h2>Information according to § 5 TMG</h2>

          <p>
            NWON GmbH
            <br /> Taunusstr. 59-61
            <br /> c/o Gutenberg Digital Hub
            <br /> 55118 Mainz
            <br />
            Commercial register: HRB 50583
            <br /> Register court: Local court Mainz
            <br />
            <br />
            <strong>Represented by:</strong>
            <br /> Felix Buchmüller
          </p>

          <h2>Contact</h2>

          <p>
            Phone: +49 6131 6246 560 <br /> E-Mail:{" "}
            <Link href={`mailto:${t("contactInformation.email")}`}>
              {t("contactInformation.email")}
            </Link>
          </p>

          <h2>EU Dispute Resolution</h2>

          <p>
            The European Commission provides a platform for online dispute
            resolution (OS):&nbsp;
            <a
              href="https://ec.europa.eu/consumers/odr/"
              target="_blank"
              rel="noreferrer"
              style={{ color: theme.palette.primary.main }}
            >
              https://ec.europa.eu/consumers/odr/
            </a>
            <br /> You can find our e-mail address in the imprint above.
          </p>

          <h2>Consumer dispute resolution/universal arbitration board</h2>

          <p>
            We are not willing or obliged to participate in dispute resolution
            proceedings before a consumer arbitration board.
            <br /> Source:&nbsp;
            <a
              href="https://www.e-recht24.de/"
              target="_blank"
              rel="noreferrer"
              style={{ color: theme.palette.primary.main }}
            >
              eRecht24
            </a>
          </p>
        </>
      ),
    },
  };
};
